import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import JournalList from "./JournalList";
import CreateJournalWizard from "./CreateJournalWizard/CreateJournalWizard";

const JournalsPage = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`} component={CreateJournalWizard} />
            <Route path={`${path}/:promptId/wizard`} component={CreateJournalWizard} />
            <Route default>
                <JournalList />
            </Route>
        </Switch>
    );
};

export default JournalsPage;
